<template>
  <div class="goods-infor">
    <div class="goods-card container">
      <!--线下商品名称-->
      <div class="goods-card-title" v-if="offlineProduct && offlineProduct.case_type == 'group'">
        {{ titleObj.title }}
      </div>
      <!--常规商品名称-->
      <div v-else class="goods-card-title">{{ goodsData.name }}</div>
      <!--未购买 商品信息-->
      <div class="goods-card-content" v-if="!is_buy">
        <!-- 指定给会员的商品 -->
        <template v-if="isVipGoods">
          <!-- 没有开通会员 -->
          <div v-if="!isFreeVipBuy">
            <div class="goods-specs-vip" @click="buyVip">
              <img src="../../assets/images/goods/specs_vip_icon.png" class="icon" />
              <p class="text">成为金标尺会员，此{{ goodsTypeText }}</p>
              <img src="../../assets/images/goods/specs_vip_arrow_icon.png" class="arrow-icon" />
            </div>
          </div>
        </template>

        <!-- 非会员商品 -->
        <div class="goods-specs" v-else>
          <div class="goods-specs-item">
            <div class="name">价格</div>
            <!--线下商品价格显示-->
            <div class="content price" v-if="offlineProduct && offlineProduct.case_type == 'group'">
              <p class="price-text price-text_new">
                <span class="symbol">￥</span>
                <span class="number">{{ titleObj.starPrice }}</span>
                <span
                  class="number"
                  style="margin: 0 0.1rem"
                  v-if="titleObj.starPrice < titleObj.endPrice"
                >
                  -
                </span>
                <span class="number" v-if="titleObj.starPrice < titleObj.endPrice">
                  {{ titleObj.endPrice }}
                </span>
              </p>
            </div>

            <!--线上商品价格显示-->
            <div class="content price" v-else>
              <!--普通商品-->
              <template v-if="goodsData.usability == 'product'">
                <!-- 有会员价格 -->
                <div v-if="isHasVipPrice">
                  <!-- 有会员价资格 -->
                  <div v-if="isVipPricePower" style="display: flex; align-items: center">
                    <p class="price-text price-text_new">
                      <span class="symbol">会员价￥</span>
                      <span class="number">{{ vipPrice }}</span>
                    </p>
                    <p class="price-text price-text_old" style="margin-left: 0.2rem">
                      <span class="symbol">￥</span>
                      <span class="number">{{ newPrice }}</span>
                    </p>
                  </div>
                  <!-- 没有会员资格 -->
                  <div v-else style="display: flex; align-items: center">
                    <p class="price-text price-text_new">
                      <span class="symbol">￥</span>
                      <span class="number">{{ newPrice }}</span>
                    </p>
                    <p class="price-text price-text_vip">
                      <span class="symbol">会员价￥</span>
                      <span class="number">{{ vipPrice }}</span>
                    </p>
                  </div>
                </div>
                <!-- 没有会员价格 -->
                <div v-else style="display: flex; align-items: center">
                  <p class="price-text price-text_new">
                    <span class="symbol">￥</span>
                    <span class="number">{{ newPrice }}</span>
                  </p>
                  <p class="price-text price-text_old" v-if="isShowOldPrice">
                    <span class="symbol">￥</span>
                    <span>{{ oldPrice }}</span>
                  </p>
                </div>
              </template>

              <!--身份下的课程-->
              <template v-if="goodsData.usability == 'identity'">
                <p class="price-text price-text_new">
                  <span class="number">真题功能包</span>
                </p>
              </template>

              <!--当前商品是功能包-->
              <template v-if="unitName == 'identity'">
                <p class="price-text price-text_new">
                  <span class="symbol">￥</span>
                  <span class="number">{{ newPrice }}</span>
                </p>
                <p class="price-text price-text_old" v-if="isShowOldPrice">
                  <span class="symbol">￥</span>
                  <span>{{ oldPrice }}</span>
                </p>
              </template>

              <!--免费商品-->
              <template v-if="goodsData.usability == 'free'">
                <p class="price-text price-text_new">
                  <span class="number">免费</span>
                </p>
              </template>
            </div>
          </div>

          <!--线上商品规格展示-->
          <template v-if="!offlineProduct">
            <div class="goods-specs-item" v-if="!isFreeGoods && goodsData.usability != 'identity'">
              <div class="name">规格</div>
              <div class="content">
                <span class="text" v-if="currentSpecs && currentSpecs.period_type == 'deadline'">
                  有效期至{{ currentSpecs.period_value }}
                </span>
                <span class="text" v-if="currentSpecs && currentSpecs.period_type == 'period'">
                  有效期{{ currentSpecs.period_value }}天
                </span>
                <img
                  class="icon"
                  v-if="productCase.case && productCase.case.length > 1"
                  :src="goodsThreePoint"
                  @click="specTriggerAction()"
                />
              </div>
            </div>
          </template>
        </div>

        <!--商品为题集时显示习题单数量-->
        <div class="question-count" v-if="unitName == 'quesion'">
          <p class="question-count-item">
            共
            <span class="number">{{ questionCount.len }}</span>
            个习题单
          </p>
          <p class="question-count-item">
            <span class="number">{{ questionCount.count }}</span>
            道题
          </p>
        </div>
      </div>

      <!--已购买 商品信息-->
      <div
        class="goods-card-content"
        v-if="is_buy && offlineProduct && offlineProduct.case_type != 'group'"
      >
        <!--规格展示-->
        <div class="goods-specs">
          <div class="goods-specs-item">
            <div class="name" style="width: 100%" v-if="goodsData.usability == 'free'">
              有效期:永久
            </div>
            <div class="name" style="width: 100%" v-else-if="goodsData.buy_expiry">
              有效期至{{ goodsData.buy_expiry }}
            </div>
          </div>
        </div>
        <!--商品为题集时显示习题单数量-->
        <template v-if="unitName == 'question'">
          <div class="question-count">
            <p class="question-count-item">
              共
              <span class="number text-color-main">{{ questionCount.len }}</span>
              个习题单
            </p>
            <p class="question-count-item">
              <span class="number text-color-main">
                {{ questionCount.count }}
              </span>
              道题
            </p>
          </div>
        </template>

        <!--题集以外的商品-->
        <template v-if="unitName !== 'question'">
          <div class="question-count course-count" v-if="isShowGoodsQQ || goodsData.intro">
            <p class="question-count-item course-count-item">
              <span class="text" v-if="goodsData.intro">
                <img :src="getCurrentBrand.imageGoodsTitleButtonText" class="icon" />
                介绍
              </span>
              <span class="text" v-if="isShowGoodsQQ">
                <img :src="getCurrentBrand.imageGoodsTitleButtonQQ" class="icon" />
                Q群
              </span>
            </p>
          </div>
        </template>
      </div>
    </div>

    <!-- 老师信息 -->
    <div class="goods-card container" v-if="teacherList.length > 0 && !is_buy">
      <div class="goods-card-title">授课老师</div>
      <div class="goods-card-content">
        <teacher-list :list="teacherList"></teacher-list>
      </div>
    </div>
    <div class="goods-card container" v-if="goodsData.pay_desc">
      <div class="goods-card-title" style="margin-bottom: 0.2rem">课程说明</div>
      <div class="goods-card-content" style="font-size: 0.35rem; color: #919499">
        {{ goodsData.pay_desc }}
      </div>
    </div>
  </div>
</template>

<script>
import teacherList from '@/components/Goods/TeacherList'

export default {
  name: 'goodsDetailInfo',
  props: {
    goodsData: Object,
    teacherList: Array,
    is_buy: Boolean,
    unitName: String,
    currentSpecs: Object,
    productCase: Object,
    offlineProduct: Object,
    titleObj: Object,
  },
  components: {
    teacherList,
  },
  data() {
    return {
      goodsThreePoint: this.$imageURL.goodsThreePoint,
    }
  },
  computed: {
    isShowGoodsQQ() {
      return this.goodsData?.qq && this.goodsData.qq.length > 0
    },
    isShowOldPrice() {
      let price = this.currentSpecs?.amount || this.productCase.price,
        old_price = this.currentSpecs?.amount_original || this.productCase.o_price
      return price !== old_price && old_price != '0.00' && old_price != '0'
    },
    // 免费商品
    isFreeGoods() {
      return this.goodsData?.usability === 'free'
    },
    // 指定给会员的商品
    isVipGoods() {
      return this.goodsData?.usability === 'membership'
    },
    // 免费会员购买
    isFreeVipBuy() {
      return this.isVipGoods && !!this.goodsData.is_buy_membership
    },
    newPrice() {
      let price = this.currentSpecs?.amount || this.goodsData.product.price
      return this.$util.clearPriceZero(price)
    },
    oldPrice() {
      let price = this.currentSpecs?.amount_original || this.goodsData.product.o_price
      return this.$util.clearPriceZero(price)
    },
    vipPrice() {
      let price = this.currentSpecs?.amount_membership || this.goodsData.product.membership_price
      return this.$util.clearPriceZero(price)
    },
    // 是否可以使用会员价购买
    isVipPricePower() {
      return this.goodsData.is_membership_price
    },
    // 是否有会员价格
    isHasVipPrice() {
      let price = this.currentSpecs?.amount_membership || this.goodsData.product.membership_price
      return !!price && price !== '0.00'
    },
    // 题集统计
    questionCount() {
      let list = this.goodsData.qv_list,
        len = list.length,
        count = 0
      list.forEach((item) => {
        count += item.question_num
      })
      return { len, count }
    },
    //商品类型文本
    goodsTypeText() {
      let text = '课程免费学'
      if (this.unitName === 'question') {
        text = '题集免费练习'
      }
      if (this.unitName === 'identity') {
        text = '功能包免费学'
      }
      return text
    },
  },
  methods: {
    specTriggerAction() {
      this.$emit('clickSpecs')
    },
    buyVip() {
      this.$emit('clickBuyVip')
    },
  },
}
</script>

<style scoped lang="scss">
.goods {
  &-card {
    padding-top: 0.2rem;
    padding-bottom: 0.5rem;

    & + & {
      border-top: 0.01rem solid #f7f8fa;
    }

    &-title {
      font-size: 0.48rem;
      line-height: 0.8rem;
      color: $color_black;
      font-weight: bold;
      margin-bottom: 0.3rem;
    }
  }

  &-infor {
    background-color: #fff;
  }

  &-specs {
    &-list {
      .van-cell::after {
        background: red;
        display: none;
      }
    }

    &-item {
      display: flex;
      padding: 0.2rem 0;

      .name {
        width: 1.28rem;
        font-size: 0.4rem;
        color: #919499;
        line-height: 0.4rem;
      }

      .content {
        position: relative;
        display: flex;
        align-items: flex-end;
        flex: 1;
        font-size: 0;

        span {
          font-size: 0.4rem;
          line-height: 0.4rem;
        }

        .icon {
          position: absolute;
          width: 0.5rem;
          top: 0;
          right: 0;
        }
      }

      .price {
        &-text {
          .symbol {
            font-size: 0.35rem;
          }

          .number {
            font-size: 0.42rem;
            // font-family: 'DIN-Bold';
            font-weight: bold;
          }

          &_new {
            color: #ff6a4d;
          }

          &_old {
            color: #919499;
            text-decoration: line-through;
          }

          &_vip {
            font-size: 0.35rem;
            color: #e5b66e;
            margin-left: 0.2rem;

            .number {
              font-size: 0.35rem;
            }
          }
        }
      }
    }
  }
}

.question-count {
  display: flex;

  &-item {
    font-size: 0.37rem;
    line-height: 0.35rem;
    color: #919499;
    padding: 0 0.2rem;
    margin-top: 0.4rem;

    &:nth-child(1) {
      padding-left: 0;
    }

    & + & {
      border-left: 1px solid #919499;
    }

    .number {
      font-size: 0.45rem;
      color: #18191a;
      font-weight: bold;
    }
  }
}

.goods-specs-vip {
  display: flex;
  align-items: center;
  height: 0.91rem;
  background: linear-gradient(to right, #fffaf0, #fffcf5);

  padding: 0 0.32rem;
  border-radius: 0.04rem;

  .icon {
    width: 0.72rem;
    height: 0.32rem;
    margin-right: 0.11rem;
  }

  .text {
    flex: 1;
    font-size: 0.35rem;
    color: #e5b66e;
  }

  .arrow-icon {
    width: 0.27rem;
    height: 0.43rem;
    justify-self: flex-end;
  }
}
</style>
